export default [
  { name: "No Alcohol (bis 0,5% vol)", short_name: "No alc.", value: 10 },
  { name: "Low Alcohol (bis 8% vol)", short_name: "Low alc.", value: 20 },
  { name: "Regular", short_name: "Regular", value: 30 }
];
